
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.594 5.907a2.584 2.584 0 010 3.653l-6.442 6.443 6.442 6.443a2.58 2.58 0 010 3.65h-.188l-9.998-10.003v-.189l9.998-9.997zm-13.44.898l.153.109v18.45l-.153.108H7.793l-.153-.109V6.913l.153-.108h2.361z","fill":"#C1C8D6","fill-rule":"evenodd"}})])
          )
        }
      }
    